import {BaseEntity} from '../../../common/entities';


export class Graduation extends BaseEntity {
    date: Date;
}
